import {
  CORE_LOAD_USER_INFO_REQUEST,
  CORE_LOAD_USER_INFO_SUCCESS,

  CORE_VERIFY_BYPASS_REQUEST,
  CORE_VERIFY_BYPASS_SUCCESS,

  CORE_ACCEPT_TERM_REQUEST,
  CORE_ACCEPT_TERM_SUCCESS,

  CORE_LOAD_LAST_USERS_REQUEST,
  CORE_LOAD_LAST_USERS_SUCCESS,

  CORE_VERIFY_LOGIN_REQUEST,
  CORE_VERIFY_LOGIN_SUCCESS,
  CORE_VERIFY_LOGIN_FAILURE,

  CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST,
  CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS,

  CORE_SEND_REPORT_REQUEST,
  CORE_SEND_REPORT_SUCCESS,

  CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST,
  CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS,

  CORE_LOAD_LOCATION_USER_REQUEST,
  CORE_LOAD_LOCATION_USER_SUCCESS,

  CORE_CHANGEEMAILNOTI_FRONTEND_REQUEST,
  CORE_CHANGEEMAILNOTI_FRONTEND_SUCCESS,

} from '../../types'

const initialState = []
export default {
  lastusers: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_LAST_USERS_REQUEST:
        return initialState
      case CORE_LOAD_LAST_USERS_SUCCESS:
        if (action.payload[0]) {
          const payload = action.payload[0]
          let lastuser = []
          for (let i = 0; i < payload.length; i++) {
            lastuser.push({ value: payload[i]._id, key: i, text: payload[i].fullName })
          }
          return lastuser
        } else
          return []

      default:
        return state
    }
  },
  userInfo: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_USER_INFO_REQUEST:
      case CORE_VERIFY_BYPASS_REQUEST:
      case CORE_VERIFY_LOGIN_REQUEST:
      case CORE_CHANGEEMAILNOTI_FRONTEND_REQUEST:
      case CORE_CHANGEEMAILNOTI_FRONTEND_SUCCESS:
        return state
      case CORE_VERIFY_LOGIN_SUCCESS:
      case CORE_LOAD_USER_INFO_SUCCESS:
      case CORE_VERIFY_BYPASS_SUCCESS:
      case CORE_VERIFY_LOGIN_FAILURE:
        return action.payload
      default:
        return {}
    }
  },
  auth: (state = initialState, action) => {
    switch (action.type) {
      case CORE_ACCEPT_TERM_REQUEST:
        return {}
      case CORE_ACCEPT_TERM_SUCCESS:
        return { ...state }
      default:
        return {}
    }
  },
  sendMailResetPassword: (state = initialState, action) => {
    switch (action.type) {
      case CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST:
        return {}
      case CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS:
        return {
          status: action.payload
        }
      default:
        return {}
    }
  },
  hasSendReport: (state = initialState, action) => {
    switch (action.type) {
      case CORE_SEND_REPORT_REQUEST:
        return []
      case CORE_SEND_REPORT_SUCCESS:
        return action.payload
      default:
        return []
    }
  },
  sendMail: (state = initialState, action) => {
    switch (action.type) {
      case CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST:
        return {}
      case CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS:
        if (typeof (action.payload) !== "undefined")
          return {
            status: action.payload
          }
        else return {}
      default:
        return state
    }
  },
  location: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_LOCATION_USER_REQUEST:
        return state
      case CORE_LOAD_LOCATION_USER_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/front/features/user/reducer.js